var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEndCall = function SvgEndCall(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 64,
    height: 64,
    rx: 12,
    fill: "#C83333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9171 34.8115L47.5966 36.4682C47.2954 38.0213 45.8399 39.0606 44.1961 38.897L40.9219 38.5704C39.4966 38.4276 38.2841 37.4102 37.9249 36.056L36.9269 32.2838C35.433 31.6658 33.7856 31.3811 31.9857 31.4284C30.252 31.4599 28.5423 31.839 26.9577 32.5432L26.3223 36.0707C26.0805 37.4061 24.9729 38.4007 23.5762 38.5357L20.3203 38.8542C18.6948 39.0122 17.1414 37.9736 16.6845 36.4246L16.1942 34.7654C15.7069 33.113 16.1514 31.376 17.3623 30.208C20.2209 27.447 24.9742 26.0747 31.6252 26.086C38.2861 26.0977 43.1821 27.4935 46.307 30.2719C47.6223 31.4408 48.2358 33.1674 47.9171 34.8115Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEndCall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "End Call.16cdc3c751220128ca054729627ed667.svg";